module.exports = __webpack_public_path__ + "static/img/bg_topo.6186ff0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_topo.jpg
// module id = fwB7
// module chunks = 1